import SoundFx from '../../../components/SoundFx';

export default function ExtensibleFeature() {
  const target = document.getElementById('ExtensibleFeature');

  target.addEventListener('mouseenter', () => {
    SoundFx.Extensible.play();
  });

  target.addEventListener('mouseleave', () => {
    SoundFx.Extensible.pause();
  });

  target.addEventListener('mousedown', () => {
    SoundFx.Extensible.speed(1.5);
  });

  target.addEventListener('mouseup', () => {
    SoundFx.Extensible.speed(1);
  });

  return target;
}
